import { projects } from "../types";
import { guid } from "../utils/common";
import lambdas from "../lambdas/apis"
import { put , takeEvery ,call } from "redux-saga/effects";


export function* resetProjectsStore(action) {
    yield put({ type: projects.RESET_PROJECTS_STORE_SUCCESS, payload: {} })
}

export function* getProjectsListNames(action) {
    const { customer_id, allowAll } = action.payload
    try {
        const response = yield call(lambdas.projects.getProjectsListNames, {}, {}, { customer_id });
        if (response.data.code === 200) {
            let projectNameList = [];
                response.data.data.map(project => {
                return projectNameList.push({
                 key: `${guid()}_${project.project_owned_by}`,
                 value: project.id,
                 text: project.project_name,
                 project
                      })
             });
            if (allowAll) {
                projectNameList.push({
                    key: 'all',
                    value: 'all',
                    text: 'All'
                });
            }
            yield put({ type: projects.PROJECT_LIST_NAMES_SUCCESS, payload: projectNameList })
        } else {
            yield put({ type: projects.PROJECT_LIST_NAMES_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: projects.PROJECT_LIST_NAMES_FAILURE, payload: error })
    }
}


export default function* projectSaga() {
    yield takeEvery(projects.RESET_PROJECTS_STORE_REQUEST, resetProjectsStore)
    yield takeEvery(projects.PROJECT_LIST_NAMES_REQUEST, getProjectsListNames)
}